module.exports = __webpack_public_path__ + "static/media/072-folder.fe258f6b.svg";